export const keys = {
  mode: 'mode',
  displayType: 'displayType',
  filter: 'filter',
  sort: 'sort',
  entityDefUuid: 'entityDefUuid',
  attributeDefUuids: 'attributeDefUuids',
  dimensions: 'dimensions',
  measures: 'measures',
  filterRecordUuid: 'filterRecordUuid',
  filterRecordUuids: 'filterRecordUuids',
}

export const modes = {
  raw: 'raw',
  rawEdit: 'rawEdit',
  aggregate: 'aggregate',
}

export const displayTypes = {
  table: 'table',
}
